import React from 'react';
import Screen from '../../Screen';
import LiveVotingTopBar from './LiveVotingTopBar';
import Scrollable from '../../../elements/Scrollable';

export default WrappedComponent => {
    return class LiveVotingScreen extends React.Component {
        render() {
            let {i18n, event} = this.props,
                header = (
                    <div>
                        <LiveVotingTopBar {...this.props}/>
                    </div>
                );

            return (
                <Screen className="LiveVoting main" header={header}>
                    <Scrollable>
                        <WrappedComponent {...this.props} />
                    </Scrollable>
                </Screen>
            );
        }
    };
};
